import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLock, FiArrowLeft } from 'react-icons/fi';
import { useAuth } from '../../hooks/AuthContext';

const SinAcceso = () => {
    const navigate = useNavigate();
    const { user } = useAuth();

    // Find first permitted module to redirect user
    const perms = user?.appPermissions || {};
    const permMap = [
        { key: 'calendario', path: '/calendar' },
        { key: 'tareas', path: '/tareas' },
        { key: 'horasExtra', path: '/horas-extras' },
    ];
    const firstAllowed = permMap.find(m => perms[m.key] !== false);
    const backPath = user?.role === 'admin'
        ? '/inicio'
        : user?.isInstructor && !user?.isCollaborator
            ? '/mi-calendario'
            : firstAllowed?.path || '/sin-acceso';

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
            <div className="max-w-md w-full text-center bg-white rounded-2xl shadow-xl p-10 border border-gray-100">
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-red-50 mb-6">
                    <FiLock size={36} className="text-red-400" />
                </div>
                <h1 className="text-2xl font-bold text-gray-900 mb-3">Acceso restringido</h1>
                <p className="text-gray-500 text-sm mb-2">No tienes permiso para acceder a este módulo.</p>
                <p className="text-gray-400 text-xs mb-8">
                    Si crees que es un error, contacta al administrador para que te otorgue acceso.
                </p>
                {backPath !== '/sin-acceso' ? (
                    <button
                        onClick={() => navigate(backPath)}
                        className="inline-flex items-center gap-2 px-6 py-2.5 bg-indigo-600 text-white rounded-xl font-medium text-sm hover:bg-indigo-700 transition shadow"
                    >
                        <FiArrowLeft size={14} /> Ir a mi inicio
                    </button>
                ) : (
                    <p className="text-xs text-amber-600 bg-amber-50 rounded-lg px-4 py-3">
                        Tu cuenta no tiene ningún módulo habilitado aún. Contacta al administrador.
                    </p>
                )}
            </div>
        </div>
    );
};

export default SinAcceso;
